import { render, staticRenderFns } from "./ProductImports.vue?vue&type=template&id=7b42a244&"
import script from "./ProductImports.vue?vue&type=script&lang=js&"
export * from "./ProductImports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports